import sanitizeHtml from 'sanitize-html';

/*
 * Decode html entities
 * description: This function decodes html entities in a string
 * @param {string} html - html string
 * @returns {string} - decoded html string
 */
const decodeHtmlEntities = (html: string) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

export const truncateHtml = (text: string, maxCharacterNumber: number) => {
  // Sanitize HTML
  const sanitizedHtml = sanitizeHtml(text, {
    allowedTags: [],
    allowedAttributes: {},
  });

  // Decode HTML entities
  const decodedHtml = decodeHtmlEntities(sanitizedHtml);

  // if the decoded HTML is shorter than the max character number, return it
  if (decodedHtml.length <= maxCharacterNumber) return decodedHtml;

  // Truncate the decoded HTML
  let truncatedHtml = `${decodedHtml.slice(0, maxCharacterNumber)}...`;

  return truncatedHtml;
};
